import { useTranslation } from 'react-i18next'

import Button from '../../../../../Button'
import Text from '../../../../../Text'
import { RentalPortalTimelineMarker } from '../../../../RentalPortalTimelineMarker'
import { QA_NAME_LISTING_PROFILE_READINESS_FIX_BTN } from '../RentalPortalListingProfileWidgetPublishing.constants'

import * as styles from './ListingProfileWidgetPublishingCheck.module.css'

function ListingProfileWidgetPublishingCheck({
  hintKey,
  isDone,
  isFixable,
  isLast,
  isLineDone,
  labelKey,
  onClickFix,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.ListingProfileWidgetPublishingCheck}>
      <RentalPortalTimelineMarker
        isDone={isDone}
        isLast={isLast}
        isLineDone={isLineDone}
      />

      <div className={isLast ? styles.contentLast : styles.content}>
        {isFixable ? (
          <Button.Text
            isGrey
            className={styles.fixButton}
            qaName={QA_NAME_LISTING_PROFILE_READINESS_FIX_BTN}
            text={t(labelKey)}
            textClassName={styles.label}
            onClick={onClickFix}
          />
        ) : (
          <Text className={styles.label}>{t(labelKey)}</Text>
        )}

        {hintKey ? (
          <Text isSecondary className={styles.hint}>
            {t(hintKey)}
          </Text>
        ) : null}
      </div>
    </div>
  )
}

export default ListingProfileWidgetPublishingCheck
